import {ILookupTable} from './interfaces/Itable.lookup';
import {LookupRequest} from './request.lookup';

/**
	**********************************************************************
	* The class represents response of lookup request.
	*
	* Written by: Dana Moshe
	**********************************************************************
	*/
export class LookupResponse<T> {

	/**
		* @param lookupTable The lookup data that return from the server.
		* @param lookupRequest The lookup request that sent.
		*/
	constructor(public lookupTable:ILookupTable<T>, public lookupRequest:LookupRequest) {
	}
}

